module.exports = __webpack_public_path__ + "static/media/langganan.2ccd61f9.svg";